import { useCallback } from 'react';

import { useAuth } from '@kaiizen/kai-pro-api-react-state';

import { useClearCache } from './useClearCache';

/**
 * Super admin only: switches the session into any org (member or not), keeping the original session to switch back to,
 * then reloads so every cached query refetches under the new org.
 */
export const useSuperAdminSwitchToOrg = () => {
  const { credentialsMutators } = useAuth();
  const clearCache = useClearCache();
  return useCallback(async (orgId: string) => {
    console.warn('Super admin switching to non-member org', { targetOrgId: orgId });
    await credentialsMutators.switchOrg(orgId, { preserveOriginalSession: true });
    await clearCache();
    setTimeout(() => window.location.reload(), 1000);
  }, [credentialsMutators, clearCache]);
};
